export type AuditFinding = {
  'finding_id': string
  'order_id': number
  store: string
  kind: string
  detail: string
  'amount_minor': number
  'brand_order_ref': string | null
  'detected_at': string
  status: 'OPEN' | 'CORRECTED'
  'corrected_at': string | null
}
export async function readAuditFindings (client: any, status: 'OPEN' | 'CORRECTED'): Promise<AuditFinding[]> {
  const rows: AuditFinding[] = []
  for (let start = 0; ; start += 1000) {
    const { data, error } = await client.from('purchase_audit_findings')
      .select('finding_id,order_id,store,kind,detail,amount_minor,brand_order_ref,detected_at,status,corrected_at')
      .eq('status', status).order('detected_at', { ascending: false }).order('finding_id').range(start, start + 999)
    if (error || !Array.isArray(data)) throw new Error('No se pudo cargar Auditoría. Vuelve a intentarlo.')
    rows.push(...data)
    if (data.length < 1000) return rows
  }
}
export async function correctAuditFinding (client: any, id: string): Promise<void> {
  const { data, error } = await client.from('purchase_audit_findings').update({ status: 'CORRECTED' })
    .eq('finding_id', id).select('finding_id,status')
  if (error || !Array.isArray(data) || data.length !== 1 || data[0].status !== 'CORRECTED') throw new Error('No se pudo marcar como corregido. Actualiza la lista y vuelve a intentarlo.')
}
